import { Component, OnInit, ViewChild } from '@angular/core';
import { User } from 'src/app/beans/login/user/user.bean';
import { Service } from 'src/app/beans/service/service.bean';
import { Slot } from 'src/app/beans/slot/slot.bean';
import { ServiceSelect } from 'src/app/components/select/service/service-select/service.select';
import {
  CustomButton,
  CustomColumn,
  CustomIconButton,
  CustomTableComponent,
  HeaderButton,
  PDFExportButton,
  RowStyleFilter,
} from 'src/app/components/table/custom-table/custom-table.component';
import { HandlerManager } from 'src/app/managers/handler/handler.manager';
import { LoadingManager } from 'src/app/managers/loading/loading.manager';
import { PipeManager } from 'src/app/managers/pipe/pipe.manager';
import { SessionManager } from 'src/app/managers/session/session.manager';
import { DatePipe } from '@angular/common';
import { DialogsReturnCode } from 'src/app/enums/dialogs/returnCode.enum';
import { GenericDialog } from 'src/app/dialogs/generic/generic.dialog';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { SlotDialog } from 'src/app/dialogs/slot/slot.dialog';
import { SlotPrenotationDialog } from 'src/app/dialogs/slot-prenotation/slot.prenotation.dialog';
import { Site } from 'src/app/beans/site/site.bean';
import { SiteSelect } from 'src/app/components/select/site/site-select/site.select';
import { SlotMassImportDialog } from 'src/app/dialogs/slot-mass-import/slot.mass.import.dialog';
import { OrganizationSelect } from 'src/app/components/select/organization/organization-select/organization.select';
import { UtilsManager } from 'src/app/managers/utils/utils.manager';
import { SlotVisibility } from 'src/app/beans/slot/slot.visibility.bean';
import { LegendElement } from 'src/app/components/legenda/legenda.component';
import { AuthLevel } from 'src/app/enums/auth/auth.enum';

@Component({
  selector: 'booking-management-page',
  templateUrl: './booking.management.page.html',
  styleUrls: ['./booking.management.page.scss'],
})
export class BookingManagementPage implements OnInit {
  minDate: Date = new Date();
  chooseDate: string = this.initDate();

  orgManager: OrganizationSelect;
  @ViewChild('orgManager') set _orgSelect(orgSelect: OrganizationSelect) {
    if (orgSelect) {
      this.orgManager = orgSelect;
    }
  }

  site: Site;
  @ViewChild('siteManager') set _siteSelect(siteSelect: SiteSelect) {
    if (siteSelect) {
      this.setSite(siteSelect.getSelectedValue());
    }
  }

  service: Service;
  @ViewChild('serviceManager') set _serviceSelect(
    serviceSelect: ServiceSelect
  ) {
    if (serviceSelect) {
      this.setService(serviceSelect.getSelectedValue());
    }
  }

  bookingServiceColums: CustomColumn[] = [
    {
      isId: true,
      label: 'id',
      name: 'id',
      display: (val: any) => false,
    },
    {
      label: 'bookCode',
      name: 'tables.booking.labels.bookCode',
      pipe: (bookCode: any) => this._pipe.tables().is_not_null(bookCode, '-'),
    },
    {
      label: 'identifier',
      name: 'tables.booking.labels.identifier',
      pipe: (identifier: any) =>
        this._pipe.tables().is_not_null(identifier, '-'),
    },
    {
      label: 'timeBegin',
      name: 'tables.booking.labels.timeBegin',
    },
    // {
    //   label: "booked",
    //   name : "tables.booking.labels.booked",
    //   pipe : (booked: any) => this._pipe.tables().is_bookable(booked),
    // },
    // {
    //   label: "bookable",
    //   name : "tables.booking.labels.bookable",
    //   pipe : (bookable: any) => this._pipe.tables().is_bookable(bookable),
    // },
    // {
    //   label: "sameDayBook",
    //   name : "tables.booking.labels.sameDayBook",
    //   pipe : (sameDayBook: any) => this._pipe.tables().is_sameDayBook(sameDayBook),
    //   translate_param: { date: this._datepipe.transform(this.chooseDate, 'dd-MM') }
    // },
    {
      label: 'note',
      name: 'tables.booking.labels.note',
      pipe: (note: any) => this._pipe.tables().is_not_null(note, '-'),
    },
  ];

  booking_rows_style: RowStyleFilter[] = [
    {
      rule: (index: number, row: Slot) =>
        row.sameDayBook == 1 && index % 2 == 0,
      style: { 'background-color': '#fbed97' },
    },
    {
      rule: (index: number, row: Slot) =>
        row.sameDayBook == 1 && index % 2 == 1,
      style: { 'background-color': '#fcf3b5' },
    },
    {
      rule: (index: number, row: Slot) =>
        row.sameDayBook == 2 && index % 2 == 0,
      style: { 'background-color': '#f9c690' },
    },
    {
      rule: (index: number, row: Slot) =>
        row.sameDayBook == 2 && index % 2 == 1,
      style: { 'background-color': '#fbdab6' },
    },
    {
      rule: (index: number, row: Slot) =>
        row.sameDayBook == 3 && index % 2 == 0,
      style: { 'background-color': '#d6fb92' },
    },
    {
      rule: (index: number, row: Slot) =>
        row.sameDayBook == 3 && index % 2 == 1,
      style: { 'background-color': '#e3fcb5' },
    },
    {
      rule: (index: number, row: Slot) =>
        row.sameDayBook == 8 && index % 2 == 0,
      style: { 'background-color': '#C9ABD8' },
    },
    {
      rule: (index: number, row: Slot) =>
        row.sameDayBook == 8 && index % 2 == 1,
      style: { 'background-color': '#E4D5EC' },
    },
    {
      rule: (index: number, row: Slot) =>
        row.sameDayBook == 9 && index % 2 == 0,
      style: { 'background-color': '#95e8e9' },
    },
    {
      rule: (index: number, row: Slot) =>
        row.sameDayBook == 9 && index % 2 == 1,
      style: { 'background-color': '#c5f2f3' },
    },
  ];

  booking_legend: LegendElement[] = [];
  /*
  booking_legend: LegendElement[] = [
    {
      text  : "visibility.always",
      colors: ["#ffffff", "rgba(0, 0, 0, 0.05)"]
    },
    {
      text  : "visibility.same",
      colors: ["#fbed97", "#fcf3b5"]
    },
    {
      text  : "visibility.previous",
      colors: ["#f9c690", "#fbdab6"]
    },
    {
      text  : "visibility.4previous",
      colors: ["#d6fb92", "#e3fcb5"]
    },
    {
      text  : "visibility.reserved",
      colors: ["#C9ABD8", "#E4D5EC"]
    },
    {
      text  : "visibility.noapp",
      colors: ["#95e8e9", "#c5f2f3"]
    }
  ]
*/
  icon_buttons: CustomIconButton[] = [
    {
      label: 'manage',
      column: 'tables.booking.action.manage',
      icon: 'collections_bookmark',
      tooltip: 'tables.booking.tooltip.manage',
      action: (el: any, pos: number) => {
        this.doAction('manage-prenotation', el);
      },
      display: (row: Slot) => this.isManageable(row),
    },
    {
      label: 'delete',
      column: 'tables.booking.action.delete',
      icon: 'delete',
      tooltip: 'tables.booking.tooltip.delete',
      action: (el: any, pos: number) => {
        this.doAction('delete-prenotation', el);
      },
      display: (row: Slot) => this.isSlotDeletebale(row),
    },
    {
      label: 'update_slot',
      column: 'tables.booking.action.update_slot',
      icon: 'edit',
      tooltip: 'tables.booking.tooltip.update_slot',
      action: (el: any, pos: number) => {
        this.doAction('update-slot', el);
      },
      display: (row: Slot) => this.isTimePassedOrUpdatable(row),
    },
  ];

  header_buttons: HeaderButton[] = [
    {
      label: 'create',
      name: 'tables.booking.header_button.create',
      action: async () => {
        this.openDialog('create', null);
      },
      display: () => true && (!this.isAQP() || this.isAQPManager()),
      //display  : () => true
    },
    {
      label: 'mass_insert',
      name: 'tables.booking.header_button.mass_insert',
      action: async () => {
        this.openDialog('mass-import', null);
      },
      display: () =>
        this.values &&
        this.values.length > 0 &&
        (!this.isAQP() || this.isAQPManager()),
    },
  ];

  pdf_buttons: PDFExportButton[] = [
    {
      label: 'download_booked',
      name: 'Scarica elenco prenotazioni',
      config: {
        filename: () =>
          `prenotazioni ${this.chooseDate} ${this.site.name} ${this.service.name}.pdf`,
        columnsRule: (column: CustomColumn) => {
          return (
            column &&
            (column.label == 'bookCode' ||
              column.label == 'identifier' ||
              column.label == 'timeBegin' ||
              column.label == 'note' ||
              column.label == 'phone')
          );
        },
        rowsRule: (slot: Slot) => {
          return slot && slot.booked == 1;
        },
      },
      display: () => {
        if (!this.values || this.values.length <= 0) return false;
        const find = this.values.find((book) => book.booked == 1);
        return find != undefined && find != null;
      },
    },
  ];

  @ViewChild('bookingTable') bookingTable: CustomTableComponent;

  //----------------------------------------------------------------------------------------------

  values: Slot[] = [];
  visibilities: SlotVisibility[] = [];

  constructor(
    private _handler: HandlerManager,
    private _loader: LoadingManager,
    private _session: SessionManager,
    private _pipe: PipeManager,
    private _dialog: MatDialog,
    private _datepipe: DatePipe,
    private _util: UtilsManager
  ) {}

  ngOnInit(): void {}

  initDate() {
    return this._datepipe.transform(new Date(), 'yyyy-MM-dd');
  }

  setSite(site: Site) {
    this.site = site;
  }

  setService(service: Service) {
    this.service = service;
    this.loadComponents();
    this.init();
  }

  loadComponents() {
    console.log('isAQP? --->' + (!this.isAQP() || this.isAQPManager()));

    if (this.site && (!this.isAQP() || this.isAQPManager())) {
      if (!this.searchInButtonsArray(this.icon_buttons, 'delete_slot')) {
        this.icon_buttons.push({
          label: 'delete_slot',
          column: 'tables.booking.action.delete_slot',
          icon: 'clear',
          tooltip: 'tables.booking.tooltip.delete_slot',
          action: (el: any, pos: number) => {
            this.openDialog('delete', el);
          },
          display: (row: Slot) => this.isSlotDeletebale(row),
        });
      }

      if (!this.searchInButtonsArray(this.header_buttons, 'delete_all')) {
        this.header_buttons.push({
          label: 'delete_all',
          name: 'tables.booking.header_button.delete_all',
          action: async () => {
            this.openDialog('delete-all-slot', null);
          },
          display: () => this.values && this.values.length > 0,
        });
      }
    }
    if (this.site && this.isAQP()) {
      if (!this.searchInButtonsArray(this.bookingServiceColums, 'phone')) {
        this.bookingServiceColums.push({
          label: 'phone',
          name: 'tables.booking.labels.phone',
          pipe: (phone: any) => this._pipe.tables().is_not_null(phone, '-'),
        });
      }
    }
  }

  searchInButtonsArray(array: any[], field: string) {
    if (!array) return false;

    const find = array.find((el) => el.label == field);

    return find != null && find != undefined;
  }

  async init() {
    if (this.service) {
      this.values = await this.retriveValues(this.chooseDate.toString());
      this.visibilities = await this.getVisibility();
      this.prepareLegenda();
    }
  }

  //----------------------------------------------------------------------------------------------

  async delete_all_slot(item: any, index: number, array: any[]) {
    await this.deleteAllSlot();
    this.init();
  }

  async doAction(action: string, el: any) {
    if (action == 'update-slot') {
      this.openDialog('update-slot', el);
    }
    if (action === 'manage-prenotation') {
      this.openPrenotationDialog('manage', el);
    } else if (action == 'delete-prenotation') {
      this.openPrenotationDialog('delete', el);
    }
  }

  //----------------------------------------------------------------------------------------------

  async openDialog(action: string, slot: Slot) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    let dialog: any;
    if (action && action == 'mass-import') {
      dialogConfig.data = {
        currentDate: this.chooseDate,
        service: this.service,
        bookableDayId: this.values[0].bookableDayId,
        orgId: this.orgManager.currentValue.id,
      };

      dialog = this._dialog.open(SlotMassImportDialog, dialogConfig);
    } else if (action && action == 'update-slot') {
      if (!this.isTimePassedOrUpdatable(slot)) return;

      this.visibilities = await this.getVisibility();
      this.prepareLegenda();

      dialogConfig.data = {
        visibilities: this.visibilities,
        serviceId: this.service.id,
        slot: slot,
        date: this.chooseDate,
      };

      dialog = this._dialog.open(SlotDialog, dialogConfig);
    } else if (action && action != 'delete' && action != 'delete-all-slot') {
      this.visibilities = await this.getVisibility();
      this.prepareLegenda();

      dialogConfig.data = {
        visibilities: this.visibilities,
        serviceId: this.service.id,
        date: this.chooseDate,
      };

      dialog = this._dialog.open(SlotDialog, dialogConfig);
    } else if (action == 'delete-all-slot')
      dialog = this._dialog.open(GenericDialog, dialogConfig);
    else if (action && !this.isTimePassed(slot)) {
      dialog = this._dialog.open(GenericDialog, dialogConfig);
    } else return;

    dialog.afterClosed().subscribe(async (data: any) => {
      //Delete message and refresh table data
      if (data.code == DialogsReturnCode.OPERATION_ACCEPTED) {
        if (action && action == 'delete-all-slot') await this.deleteAllSlot();
        else if (action && action == 'delete') await this.deleteSlot(slot);

        this.values = await this.retriveValues(this.chooseDate);
        this.prepareLegenda();
      }

      //Refresh table data
      if (data.code == DialogsReturnCode.SLOT_OPERATION_ACCEPTED) {
        this.values = await this.retriveValues(this.chooseDate);
        this.prepareLegenda();
      }

      if (data.code == DialogsReturnCode.SLOT_MASS_IMPORT_ACCEPTED) {
        this.values = await this.retriveValues(this.chooseDate);
        this.prepareLegenda();
      }
    });
  }

  openPrenotationDialog(action: string, slot: Slot) {
    if (!this.isManageable(slot)) return;

    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    let dialog: any;
    if (action && action != 'delete') {
      dialogConfig.data = {
        site: this.site,
        service: this.service,
        slot: slot,
        date: this.chooseDate,
      };

      dialog = this._dialog.open(SlotPrenotationDialog, dialogConfig);
    } else if (action) {
      if (slot.bookCode) {
        dialogConfig.data = {
          confirm_code: true,
          body: 'dialog.generic.confirm_delete_prenotation',
          input_code: slot.bookCode,
        };

        dialog = this._dialog.open(GenericDialog, dialogConfig);
      }
    } else return;

    if (dialog) {
      dialog.afterClosed().subscribe(async (data: any) => {
        //Delete prenotation and refresh table data
        if (data.code == DialogsReturnCode.PRENOTATION_DELETE) {
          await this.deletePrenotation(slot.id);
          this.values = await this.retriveValues(this.chooseDate);
          this.prepareLegenda();
        }

        //Refresh table data
        if (data.code == DialogsReturnCode.SLOT_OPERATION_ACCEPTED) {
          this.values = await this.retriveValues(this.chooseDate);
          this.prepareLegenda();
        }
      });
    }
  }

  //----------------------------------------------------------------------------------------------

  async retriveValues(date: string) {
    const user = this._session.user().get();

    if (!User.isKind(user)) return; // TODO handle user incorrect

    this._loader.start();
    this.bookingTable.reloadData();

    let response = null;

    response = await this._handler
      .slot()
      .list(
        (user as User).token,
        this.orgManager.getSelectedValue().id,
        this.service.id,
        date
      );

    this._loader.stop();
    this.bookingTable.dataLoaded();

    if (!response) return;
    if (!response.list) return;

    return response.list as Slot[];
  }

  async getVisibility() {
    this._loader.start();

    let response = null;
    response = await this._handler.slot().visibility();

    this._loader.stop();

    if (!response) return;
    if (!response.list) return;

    return response.list as SlotVisibility[];
  }

  async getDay(date: string, type: number) {
    const user = this._session.user().get();

    if (!User.isKind(user)) return; // TODO handle user incorrect

    this._loader.start();
    this.bookingTable.reloadData();

    let response = null;

    response = await this._handler
      .slot()
      .day((user as User).token, this.service.id, date, type);

    this._loader.stop();
    this.bookingTable.dataLoaded();

    if (!response || !response.object || !response.object.day) return;

    return response.object.day;
  }

  async deleteSlot(slot: Slot) {
    const user = this._session.user().get();

    if (!User.isKind(user)) return; // TODO handle user incorrect

    this._loader.start();

    await this._handler
      .slot()
      .delete(
        (user as User).token,
        this.service.id,
        this.chooseDate,
        slot.timeBegin
      );

    this._loader.stop();
  }

  async deletePrenotation(slotId: number) {
    const user = this._session.user().get();

    if (!User.isKind(user)) return; // TODO handle user incorrect

    console.log(slotId);

    const param = this.createParams(slotId);

    this._loader.start();

    await this._handler
      .slot()
      .deletePrenotation(
        (user as User).token,
        this.orgManager.getSelectedValue().id,
        this.service.id,
        slotId,
        param
      );

    this._loader.stop();
  }

  //Delete all not booked slot in current day
  async deleteAllSlot() {
    const user = this._session.user().get();

    if (!User.isKind(user)) return; // TODO handle user incorrect

    this._loader.start();

    await this._handler
      .slot()
      .deleteAll((user as User).token, this.service.id, this.chooseDate);

    this._loader.stop();
  }

  //----------------------------------------------------------------------------------------------

  async dateChange() {
    this.chooseDate = this._datepipe.transform(this.chooseDate, 'yyyy-MM-dd');

    console.log(this.bookingServiceColums);

    this.values = await this.retriveValues(this.chooseDate);
    this.prepareLegenda();
  }

  async click(action: string) {
    //On click call service /day
    let day: any;
    switch (action) {
      case 'fast_back': {
        day = await this.getDay(this.chooseDate.toString(), 0);
        break;
      }

      case 'back': {
        day = await this.getDay(this.chooseDate.toString(), 1);
        break;
      }

      case 'next': {
        day = await this.getDay(this.chooseDate.toString(), 2);
        break;
      }

      case 'fast_next': {
        day = await this.getDay(this.chooseDate.toString(), 3);
        break;
      }
    }
    if (day) {
      this.chooseDate = day;
      this.dateChange();
    }
    this.values = await this.retriveValues(this.chooseDate.toString());
    this.prepareLegenda();
  }

  isAQP() {
    return this.site && this.site.organizationId == 200;
  }

  isAQPManager() {
    const user = this._session.user().get();

    if (!user || !User.isKind(user)) return false;

    return this.isAQP() && (user as User).level == AuthLevel.ORG_MANAGER;
  }

  isManageable(slot: Slot) {
    if (!slot || this.isTimePassed(slot)) return false;
    switch (slot.sameDayBook) {
      case 1:
        return this._util.date().isToday(this.chooseDate);
      case 2:
        const today = this._util.date().getToday();
        return this._util.date().isPrevious(today, this.chooseDate);
      case 3:
        const today2 = this._util.date().getToday();
        const agoDays = this._util.date().addDay(this.chooseDate, -4);
        return (
          this._util.date().isNext(today2, agoDays) ||
          //||  this._util.date().isSameDay     (today2          , this.chooseDate )
          this._util.date().isSameDay(today2, agoDays)
        );
      default:
        return true;
    }
  }

  isUpdateble(slot: Slot) {
    return !slot.booked && (!this.isAQP() || this.isAQPManager());
  }

  isDeletable(slot: Slot) {
    return slot && slot.booked == 1 && !this.isTimePassed(slot);
  }

  isSlotDeletebale(slot: Slot) {
    return (
      slot &&
      (slot.booked == 1 || !this.isAQP() || this.isAQPManager()) &&
      !this.isTimePassed(slot)
    );
  }

  isTimePassedOrUpdatable(slot: Slot) {
    if (!this.isUpdateble(slot) || this.isTimePassed(slot)) return false;
    return true;
  }

  isTimePassed(slot: Slot) {
    const date = new Date();
    if (!this._util.date().isToday(this.chooseDate)) return false;
    const slotTime = this._util.time().timeToDate(slot.timeBegin);
    if (!slotTime) return true;

    return slotTime < date;
  }

  check(slotId: number) {
    const slot = this.values.find((slot) => (slot.id = slotId));
    console.log(JSON.stringify(slot));
  }

  createParams(slotId: number) {
    const slot = this.values.find((slot) => slot.id == slotId);

    return [
      { k: 'SITE_NAME', v: this.getAQPSiteName() },
      { k: 'SERVICE_NAME', v: this.getAQPServiceName() },
      {
        k: 'DATE',
        v: this._util.date().toFormat(this.chooseDate, 'dd/MM/yyyy', 'it'),
      },
      { k: 'TIME', v: slot?.timeBegin },
      { k: 'PHONE', v: slot?.phone },
      { k: 'BOOK_CODE', v: slot?.bookCode },
    ];
  }

  getAQPSiteName() {
    if (!this.site || !this.site.name) return '';
    try {
      const onlyName = this.site.name.substring(19);
      if (onlyName.length > 14) return onlyName.substring(0, 14);
      return onlyName;
    } catch (error) {
      return this.site.name;
    }
  }

  getAQPServiceName() {
    if (!this.service || !this.service.name) return '';
    try {
      return this.service.name.substring(0, 16);
    } catch (error) {
      return this.service.name;
    }
  }

  prepareLegenda() {
    const legenda: LegendElement[] = [];

    this.visibilities.forEach((vis) => {
      const el = this.values.find((slot) => slot.sameDayBook == vis.id);
      if (el)
        legenda.push({
          text: vis.i18n,
          colors: [vis.primaryColor, vis.secondaryColor],
        });
    });
    this.booking_legend = legenda;
  }
}
